module.exports = __webpack_public_path__ + "static/assets/706241f2f657ab1bbbf29f3e76c476bf.png";